import React from 'react';
import { Link } from 'react-router-dom';
import './Dropdown.css';
import { usePermissoes } from '../utils/PermissoesContext';

export default function DropdownEstoque({ onLinkClick }) {
  const { temPermissao } = usePermissoes();
  
  return (
    <div className="dropdown-submenu-content">
      {temPermissao('Produto') && <Link to="/sidebar/ProdutoDropdown" onClick={onLinkClick}>Produtos</Link>}
      {temPermissao('Estoque') && <Link to="/sidebar/EstoqueMaterialDropdown" onClick={onLinkClick}>Estoque Material</Link>}
    </div>
  );
} 
